import axios from "axios";
import Config from "../utils/Config";

class AuthRestService{
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };

      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

      async login(formData) {
        //console.log(JSON.stringify(formData));
        const data = await axios.post(
          Config.BACKEND_URL + "/api/auth/login", //login
          formData,
          this.config
        )
        return data.data;
      }

      async getAllGroups (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/auth/groupDropDown", //api/auth/groupDropDown
                this.config
            )
            return data.data;
        }
  
      async getAllCompanys (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/auth/companyDropDown/${groupId}`, //api/auth/companyDropDown/{GroupId}
                this.config
            )
            return data.data;
        }

        async forgotPassword (accessToken, groupId, companyId, formData){
          this.setAccessToken(accessToken, groupId, companyId);
              const data = await axios.post(
                  Config.BACKEND_URL + "/api/auth/forgotPassword", //api/auth/forgotPassword
                  formData,
                  this.config
              )
              return data.data;
          }

          async resetPassword (accessToken, groupId, companyId, formData){
            this.setAccessToken(accessToken, groupId, companyId);
                const data = await axios.post(
                    Config.BACKEND_URL + `/api/auth/resetPassword/${accessToken}`, //api/auth/resetPassword
                    formData,
                    this.config
                )
                return data.data;
            }

          async firstTimeResetPassword (accessToken, groupId, companyId, formData){
            this.setAccessToken(accessToken, groupId, companyId);
                const data = await axios.post(
                    Config.BACKEND_URL + "/api/auth/initialPasswordUpdate", //api/auth/initialPasswordUpdate
                    formData,
                    this.config
                )
                return data.data;
            }
}

export default new AuthRestService();